'use client';

import { getRegionByLocale } from '@/components/SicilyPages/utils';
import useGlobalContext from '@/hooks/useGlobalContext';
import {
  Experience,
  ExperienceFromBySlugRequest,
} from '@/services/experienceTypes';
import { normalizeRegion } from '@/utils/normalizeRegion';
import { useParams } from 'next/navigation';
import { useEffect } from 'react';

export function ExperienceSetDynamicUrls({
  category,
  experience,
}: {
  category: ExperienceFromBySlugRequest['macroCategory'];
  experience: Experience;
}) {
  const { setDynamicUrl, setIsDynamicUrl } = useGlobalContext();
  const params = useParams();

  const normalizedRegion = normalizeRegion(params.region as string);

  const categorySlugs = category.categoryTranslation.reduce(
    (acc: Record<string, string>, { locale, slug }) => {
      const experienceSlug =
        experience?.experienceTranslation.find((item) => item.locale === locale)
          ?.slug ?? '';

      let path;
      const region = getRegionByLocale(normalizedRegion, locale as Locale);
      switch (locale) {
        case 'it':
          path = `/it/${region}/esperienze/${slug}/${experienceSlug}`;
          break;
        case 'de':
          path = `/de/${region}/erfahrungen/${slug}/${experienceSlug}`;
          break;
        case 'fr':
          path = `/fr/${region}/experiences/${slug}/${experienceSlug}`;
          break;
        default:
          path = `/${region}/experiences/${slug}/${experienceSlug}`;
      }

      acc[locale] = path;
      return acc;
    },
    {},
  );

  useEffect(() => {
    setIsDynamicUrl(true);
    setDynamicUrl(categorySlugs);

    return () => {
      setIsDynamicUrl(false);
      setDynamicUrl({
        it: '',
        en: '',
        de: '',
        fr: '',
      });
    };
    // eslint-disable-next-line
  }, []);

  return null;
}
